import { Form, message } from 'antd';
import { useDispatch } from 'dva';
import { useState, useCallback, useEffect } from 'react';
import ButtonML from '@/components/button_ml/ButtonML';
import Loading from '@/components/Loading';
import styles from './AddRule.less?modules';
// import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
// import SelectML from '@/components/select_ml/SelectML';
import SelectML from '@/components/select_ml/add_select_ml/AddSelectML';
import SingInputML from '@/components/input_all_ml/add_input_ml/AddInputML';
import { toOption } from '@/utils/comUtil.js';
import { ruleStatusMap } from '@/constants.js';
// import { isNumber } from '@/utils/validation';

const AddRule = (props) => {
  const { id } = props || {};
  const { parents = {}, handleStatus = 'add' } = props || {};
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const setFrom = useCallback(() => {
    if (handleStatus === 'edit') {
      form.setFieldsValue({
        ...parents,
      });
    }
  }, [form, handleStatus, parents]);
  useEffect(() => {
    setFrom();
  }, [setFrom]);

  // 发起请求
  const onFinish = (values) => {
    setLoading(true);
    if (handleStatus === 'edit') {
      dispatch({
        type: 'ruleManageDetail/editRuleManaList',
        payload: {
          values: {
            id: parents.id,
            ...values,
          },
        },
        callback: (data) => {
          setLoading(false);

          const { code } = data || {};
          if (code) {
            message.error(data.message);
            return;
          }
          message.success('编辑成功');
          props.fetchData();
          props.handleCancel();
        },
      });
    } else {
      dispatch({
        type: 'ruleManageDetail/addRuleDetailList',
        payload: {
          values: {
            ruleBlockId: id,
            ...values,
          },
        },
        callback: (data) => {
          setLoading(false);

          const { code } = data || {};
          if (code) {
            message.error(data.message);
            return;
          }
          if (data) {
            message.success('新增成功');
          } else {
            message.error(data.message);
          }
          props.fetchData();
          props.handleCancel();
        },
      });
    }
  };

  const handleCancel = () => {
    props.handleCancel();
  };

  return (
    <Loading loading={loading}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          {handleStatus === 'edit' ? (
            ''
          ) : (
            <>
              <SingInputML
                height="47px"
                labelwidth="130px"
                inputWidth="269px"
                labelVal="规则名称"
                placeVal="请输入规则名称"
                name="ruleName"
                required={[
                  {
                    required: true,
                    message: '请输入规则名称',
                  },
                ]}
                // allowClear={true}
              />
            </>
          )}

          <SingInputML
            height="47px"
            labelwidth="130px"
            inputWidth="269px"
            labelVal="规则描述"
            placeVal="请输入规则描述"
            name="description"
            // allowClear={true}
            isTextArea={true}
            required={[
              {
                required: true,
                message: '请输入规则描述',
              },
            ]}
          />
          <SelectML
            height="47px"
            labelwidth="130px"
            inputWidth="269px"
            labelVal="规则状态"
            placeVal="请选择"
            name="ruleOutputResultStatus"
            // allowClear={true}
            option={toOption(ruleStatusMap)}
            required={[
              {
                required: true,
                message: '请选择规则状态',
              },
            ]}
          />
        </div>
        <footer className={styles.footer}>
          <ButtonML
            size="large"
            value="取消"
            htmlType="submit"
            fontsize="16px"
            onClick={handleCancel}
          />
          <ButtonML
            size="large"
            value="保存"
            htmlType="submit"
            fontsize="16px"
          />
        </footer>
      </Form>
    </Loading>
  );
};

export default AddRule;
